export const COVER_LETTER_EXAMPLE_ID = 'cover_letter_example';
export const REPORT_EXAMPLE_ID = 'report_example';

export const FILE_TYPE_MANUSCRIPT = 'manuscript';
export const FILE_ACCEPT_MANUSCRIPT = '.doc,.docx,.pdf';
export const FILE_TYPE_COVER_LETTER = 'cover_letter';
export const FILE_ACCEPT_COVER_LETTER = '.pdf,.png,.jpg,.jpeg';
export const FILE_TYPE_REVIEW = 'review';
export const FILE_ACCEPT_REVIEW = '.doc,.docx,.pdf,.png,.jpg,.jpeg';
export const FILE_TYPE_PERMISSION = 'permission';
export const FILE_ACCEPT_PERMISSION = '.pdf,.doc,.docx,.png,.jpg,.jpeg';
export const FILE_TYPE_MANUSCRIPT_BLIND = 'manuscript_blind';
export const FILE_ACCEPT_MANUSCRIPT_BLIND = '.doc,.docx,.pdf';



// WEBPACK FOOTER //
// ./src/constants/files.js